var win = window;

export var caf = win.cancelAnimationFrame
  || win.mozCancelAnimationFrame
  || function(id){ clearTimeout(id); };



//////////////////
// WEBPACK FOOTER
// /data/wp-content/themes/gottwines/node_modules/tiny-slider/src/helpers/caf.js
// module id = 18
// module chunks = 0